import React, { useState } from 'react'
import {FaBars, FaTimes} from 'react-icons/fa'
import { Link } from 'react-scroll';


const Navbar = () => {
    
    const [nav, setNav] = useState(false);

    const links = [
        {
            id: 1,
            link: 'home'
        },
        {
            id: 2,
            link: 'about'
        },
        {
            id: 3,
            link: 'portfolio'
        },
        {
            id: 4,
            link: 'technologies'
        },
        // {
        //     id: 5,
        //     link: 'contact'
        // },
    ]

  return (

          <div className='flex justify-between items-center right-0 h-20 text-white w-full fixed bg-transparent px-4 rounded-b-lg'>
        {/* Just my name */}
        <div>
            {/* <h1 className='text-5xl font-signature ml-2'>M</h1> */}
        </div>

        {/* For Desktop Menu */}
        <ul className='hidden md:flex'>

            {links.map(({id, link}) => (
                <li key={id} className='px-4 cursor-pointer capitalize font-medium text-white hover:scale-105'>
                    <Link to={link} smooth duration={500}> {link}</Link>
                </li>

            ))}


        </ul>

        {/* Switch between times icon and hamenu */}
        <div onClick={()=> setNav(!nav)} className='cursor-pointer pr-4 z-10 text-gray-500 md:hidden'>
            {nav ? <FaTimes size={30} /> : <FaBars size={30} />}
        </div>

        {/* If Dropdown is shown, display this */}
        {nav && (

        <ul className='flex flex-col justify-center items-center absolute top-0 left-0 w-full h-screen backdrop-blur-md'>
        {links.map(({id, link}) => (
                <li key={id} className='px-4 cursor-pointer capitalize font-medium py-6 text-4xl'>
                    <Link onClick={() => setNav(!nav)} to={link}> {link} </Link>
                </li>

            ))}
        </ul>

        )}

    </div>

  )
}

export default Navbar;